import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { DEFAULT_FALLBACK_LOCALE } from "../../const/locale";
import enTranslations from "../../locales/en/translation.json";
import koKrTranslations from "../../locales/ko-kr/translation.json";
import zhCnTranslations from "../../locales/zh-cn/translation.json";

// eslint-disable-next-line @typescript-eslint/no-floating-promises
i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: "en",
    fallbackLng: DEFAULT_FALLBACK_LOCALE,
    resources: {
      en: {
        translation: enTranslations,
      },
      "ko-kr": {
        translation: koKrTranslations,
      },
      "zh-cn": {
        translation: zhCnTranslations,
      },
    },
    debug: false,
    react: {
      useSuspense: false,
    },
    lowerCaseLng: true,
    initImmediate: false,
  });

export default i18n;
